// eslint-disable-next-line no-unused-vars
import { transmission, WEB_METHODS } from '../../network/index'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {

  // eslint-disable-next-line no-unused-vars
  async sendPush({commit}, payload) {
    console.log(payload.token)
    return transmission(false, WEB_METHODS.POST, `/push-test`, payload)
  },
  // eslint-disable-next-line no-unused-vars
  async updatePushToken ({commit}, payload) {
    console.log(payload.token)
    return transmission(false, WEB_METHODS.PUT, `/push-token`, payload)
  }
}

export default { state, mutations, actions }
